import { useCallback, useSyncExternalStore } from "react";

/** Whether a media query matches now, following it as it changes. False where there is no `matchMedia`. */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia?.(query);
      list?.addEventListener("change", onChange);
      return () => list?.removeEventListener("change", onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia?.(query).matches ?? false,
    () => false,
  );
}

/** Tailwind's `sm`: past it a sheet sits in the middle as a dialog, short of it it rises from the bottom. */
export function useWideScreen(): boolean {
  return useMediaQuery("(min-width: 640px)");
}
